import { DialogTitle, styled } from "@mui/material";
import { popoverName } from "../classes.js";
const PopoverTitle = styled(DialogTitle, {
  name: popoverName,
  slot: "PopoverTitle"
})(({ theme }) => ({
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(1)
}));
export {
  PopoverTitle
};
//# sourceMappingURL=PopoverTitle.js.map
